import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { ThemeContext } from 'styled-components';
// Import Shared Utils
import { getCardholderSupportPhone } from 'shared-components/src/utils/whitelabel';
// Import Component Styles
import { SupportLink } from './styles';

// How the PIN unlock notices send the cardholder to support, in the Advantage App's
// wording and order: "call {phone} or email {email}", each a link, where the phone is
// published (HRB); "email {email}" otherwise. Without a white label email, "contact
// Cardholder Support" as plain text.
const useSupportContact = () => {
  const theme = useContext(ThemeContext);
  const email = theme?.brand?.cardholderSupportEmail;
  const phone = getCardholderSupportPhone();

  if (!email) {
    return <FormattedMessage id="unlock-pin-support-team" />;
  }

  const emailLink = <SupportLink href={`mailto:${email}`}>{email}</SupportLink>;
  if (!phone) {
    return <FormattedMessage id="unlock-pin-support-email" values={{ email: emailLink }} />;
  }

  return (
    <FormattedMessage
      id="unlock-pin-support-call-email"
      values={{
        phone: <SupportLink href={`tel:${phone.dial}`}>{phone.display}</SupportLink>,
        email: emailLink,
      }}
    />
  );
};

export default useSupportContact;
